export const EMBED_PREVIEW_TITLE = "Embed preview";
export const EMBED_PREVIEW_LOADING_TITLE = "Embed preview loading";
export const EMBED_PREVIEW_LOADING_LABEL = "Loading the preview";

// Below this the note would round to a number that says nothing.
export const EMBED_PREVIEW_SCALE_NOTE_BELOW = 0.99;

export const getEmbedScaleNote = (scale: number): string =>
  `Shown at ${Math.floor(scale * 100)}% of the real size`;

// How tall the preview may grow before it is scaled down instead: roughly the
// height of the controls column beside it. Measuring the room left in the
// dialog would be a feedback loop — the preview is what makes the dialog tall.
export const EMBED_PREVIEW_MAX_HEIGHT = 420;

// A change whose page has not arrived after this long is shown as loading, so
// the preview cannot keep presenting a configuration the fields have left.
export const EMBED_PREVIEW_STALE_MS = 4000;
